enum AuthTypes {
  Google = 'google',
  Facebook = 'facebook',
  Email = 'email',
}

export default AuthTypes;
